<script lang="ts">
    import { shuffle } from './utils.ts';

    export let level: string;
    export let level_description: string;
    export let badge_description: string;
    export let prompt: string;
    export let recommended_sites: string[];

    $: shuffle(recommended_sites);
</script>

<div class="result">
    <p><span>level {level}</span><span>{level_description}</span></p>
    <div class="badge"><img src="./{level}.png" alt="{badge_description}"></div>
    <div class="prompt">{@html prompt}
        <ul>
            {#each recommended_sites as site}
            <li><a href="https://{site}">{site}</a></li>
            {/each}
            <li><a href="https://fediverse.party" target="_blank">fediverse.party</a></li>
        </ul>
    </div>
</div>

<style lang="scss">
    @import './styles/Score.scss';
</style>
